/**
 * users-permissions role ids. The admin/non-admin gates (invoice admin export,
 * the UserModal role switch) keyed off the bare numbers 1/2 in four files.
 */
export const ROLE = {
  ADMIN: 1,
  USER: 2,
} as const;
